// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-box {
  background-color: rgba(255, 255, 255, 0.15);
  padding: 1rem 1.5rem;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1.5rem;
}
.subscription-box .subscribe-input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
}
.subscription-box .subscribe-input::placeholder {
  color: #d8eaff;
  font-weight: 500;
}
.subscription-box .subscribe-input:focus {
  outline: none;
  box-shadow: none;
}
.subscription-box .subscribe-btn {
  background-color: white;
  color: #1397D5;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
  transition: background-color 0.3s ease;
}
.subscription-box .subscribe-btn:hover {
  background-color: #e0e0e0;
}

/* Animate on scroll */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animate-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Scroll Footer Wrapper */
.scroll-footer-wrapper {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
  transition: transform 0.4s ease-in-out;
  will-change: transform;
}

.popup-wrapper {
  position: fixed;
  bottom: -100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1050;
  transition: bottom 0.6s ease;
  width: 90%;
  max-width: 400px;
}
.popup-wrapper.show {
  bottom: 15px;
}
.popup-wrapper .popup-content {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.popup-wrapper .popup-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.scss"],"names":[],"mappings":"AACA;EACQ,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,YAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAAZ;AAEY;EACI,cAAA;EACA,gBAAA;AAAhB;AAGY;EACI,aAAA;EACA,gBAAA;AADhB;AAKQ;EACI,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;AAHZ;AAKY;EACI,yBAAA;AAHhB;;AAQA,sBAAA;AACA;EACI,UAAA;EACA,2BAAA;EACA,kDAAA;AALJ;;AAQA;EACI,UAAA;EACA,wBAAA;AALJ;;AAQA,0BAAA;AACA;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,sBAAA;AALJ;;AAQA;EACI,eAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,4BAAA;EACA,UAAA;EACA,gBAAA;AALJ;AAMI;EACI,YAAA;AAJR;AAMI;EACI,sBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AAJR;AAMI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAJR","sourcesContent":["\n.subscription-box {\n        background-color: rgba(255, 255, 255, 0.15);\n        padding: 1rem 1.5rem;\n        border-radius: 20px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        margin-top: 1.5rem;\n\n        & .subscribe-input {\n            flex-grow: 1;\n            background: transparent;\n            border: none;\n            color: white;\n            font-size: 20px;\n\n            &::placeholder {\n                color: #d8eaff;\n                font-weight: 500;\n            }\n\n            &:focus {\n                outline: none;\n                box-shadow: none;\n            }\n        }\n\n        & .subscribe-btn {\n            background-color: white;\n            color: #1397D5;\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            border: none;\n            font-size: 18px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-left: 0.5rem;\n            transition: background-color 0.3s ease;\n\n            &:hover {\n                background-color: #e0e0e0;\n            }\n        }\n}\n\n/* Animate on scroll */\n.animate-on-scroll {\n    opacity: 0;\n    transform: translateY(40px);\n    transition: opacity 0.8s ease, transform 0.8s ease;\n}\n\n.animate-visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n/* Scroll Footer Wrapper */\n.scroll-footer-wrapper {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: 999;\n    transition: transform 0.4s ease-in-out;\n    will-change: transform;\n}\n\n.popup-wrapper {\n    position: fixed;\n    bottom: -100%;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1050;\n    transition: bottom 0.6s ease;\n    width: 90%;\n    max-width: 400px;\n    &.show {\n        bottom: 15px;\n    }\n    & .popup-content {\n        background-color: #fff;\n        border-radius: 16px;\n        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n        overflow: hidden;\n    }\n    & .popup-image {\n        width: 100%;\n        height: auto;\n        display: block;\n        object-fit: cover;\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
